module.exports = __webpack_public_path__ + "img/Шығыс Қазақстан облысы.f49338c8.png";